module.exports = __webpack_public_path__ + "img/sec1_box4.d97984ff.jpg";